import React from 'react';
import { Car, Home } from 'lucide-react';
import { useSEO } from '../marketing/hooks.jsx';

const NotFoundPage = () => {
  // Firebase Hosting risponde 200 anche su URL inesistenti ("soft 404"):
  // senza noindex Google potrebbe indicizzare pagine vuote.
  useSEO({ noindex: true });
  return (
  <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 text-center">
    <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full">
      <div className="text-8xl font-black text-gray-200 mb-2">404</div>
      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-5">
        <Car className="w-9 h-9 text-blue-600" />
      </div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Pagina non trovata</h1>
      <p className="text-gray-500 mb-8">
        La pagina che stai cercando non esiste o è stata spostata.
      </p>
      {/* Link href per tornare alla home */}
      <a
        href="/"
        className="flex items-center justify-center gap-2 w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold transition shadow-md no-underline"
      >
        <Home className="w-5 h-5" />
        Torna alla Home
      </a>
    </div>
  </div>
  );
};

export default NotFoundPage;
